// Project image/document arrays contain either plain URL strings (new records) or
// legacy { key, name } objects. Normalise either shape to a URL string so the UI
// renders both old and new data.
export const getFileUrl = (item) =>
    typeof item === 'string' ? item : (item?.key || item?.url || item?.fileUrl || '');

// A display name for a document. Legacy objects carry a `name`; for plain URL strings
// we derive the file name from the URL (stripping any query string), else "Document".
export const getFileName = (item) => {
    if (item && typeof item === 'object' && item.name) return item.name;
    const url = getFileUrl(item);
    if (!url) return 'Document';
    try {
        const path = url.split('?')[0];
        return decodeURIComponent(path.substring(path.lastIndexOf('/') + 1)) || 'Document';
    } catch {
        return 'Document';
    }
};

export default getFileUrl;
